import React from 'react';
import withStyles from '@mui/styles/withStyles';

const Label = ({ text, children, className, htmlFor }) => (
	<label htmlFor={htmlFor} className={`form-label ${className || ''}`} >
		{children || text}
	</label>
);

export default withStyles({})(Label);
